import React from 'react';

const MatchingCriteria = () => {
  return (
    <div className="card p-4 shadow">
      <h3>My Matching Criteria</h3>
      <p className="text-muted">Set your preferences for potential matches.</p>
      <div className="alert alert-info mt-3">
        <strong>Coming Soon!</strong> This feature is under development.
      </div>
    </div>
  );
};

export default MatchingCriteria;
